const Constants = global.Constants = {
    events: {
        'LOGIN': { 'event': 'User login', 'category': 'User' },
        'REGISTER': { 'event': 'User register', 'category': 'User' },
    },
    defaultLocale: 'en',
    STORYBOOK: false,
    // boolean flag to control the referral program throughout the app
    isReferralProgramActive: true,
    simulate: {
        FORCE_LANGUAGE: false, // set to "en" etc to specify a language
        PREFILL_REGISTRATION: false,
        PREFILL_LOGIN: false,
        PREFILL_BILLING_ADDRESS: false,
        IOS_SUBSCRIPTION: false,
        ANDROID_SUBSCRIPTION: false,
        CHARGEBEE_SUBSCRIPTION: false,
        DISABLE_APPLE_PAY_ONLY: false,
        SKIP_REGISTRATION: false,
        STUDENTBEANS_LOGGED_IN: false,
        FORCE_CURRENCY: '',
        FORCE_SUBSCRIBE_COMPLETE: false,
        SB_PROFILE: {
            email: 'mystudentemail@uni.com',
            profile: {
                id: 'dunno',
                first_name: 'Dave',
                last_name: 'Mong',
                date_of_birth: '02/07/1966',
                gender: 'M',
                country: 'UK',
                avatar: 'https://www.fillmurray.com/200/200',
                student_verification: {
                    expires_in: 1469031778,
                    "university": "University of Manchester",
                },
                "grad_year": "YYYY",
                "sbid_number": "XXXXXXX"
            }
        },
    },
    statusBarHeight: 0, // gets set on launch
    pages: {
        NOT_FOUND: 'Not Found',
        HOME_PAGE: 'Home',
    },
    prefills: {
        register: {
            firstName: 'SSG',
            lastName: 'Test',
            dob: '02/06/1987',
            email: 'ssg-web-test-fail-1@ssg.com',
            password: 'Solid1234',
            confirmPassword: 'Solid1234',
        },
        login: {
            email: 'ssg-web-test-1@ssg.com',
            password: 'Solid1234',
        },
        billingAddress: {
            addressLine1: '90 Paul St',
            city: 'London',
            state: 'London',
            zip: 'EC2A 4NE',
            country: 'GB',
        },
    },
    studentbeans: {
        GB: {
            client_id: '118d294e-b0a7-494f-85b7-d1058333977c',
            country: 'uk',
        },
        US: {
            client_id: '16077ab0-9a27-430e-abe6-86b2d52a4003',
            country: 'us',
        },
        // DE: {
        //     client_id: 'todo',
        //     country: 'de',
        // },
        // CA: {
        //     client_id: 'todo',
        //     country: 'ca',
        // },
        // AU: {
        //     client_id: 'todo',
        //     country: 'au',
        // },
        // NZ: {
        //     client_id: 'todo',
        //     country: 'nz',
        // },
    },
    dateFormats: {
        GBP: 'DD/MM/YYYY',
        EUR: 'DD/MM/YYYY',
        USD: 'MM/DD/YYYY',
        CAD: 'YYYY/MM/DD',
        AUD: 'DD/MM/YYYY',
    },
    dateMasks: {
        GBP: '11/11/1111',
        EUR: '11/11/1111',
        USD: '11/11/1111',
        CAD: '1111/11/11',
        AUD: '11/11/1111',
    },
    appStorePrices: {
        GBP: {
            monthly_7_day_trial: 13.99,
            quarterly_7_day_trial: 34.99,
            yearly_7_day_trial: 84.99,
            'monthly_7_day_trial.staging': 13.99,
            'quarterly_7_day_trial.staging': 34.99,
            'yearly_7_day_trial.staging': 84.99,
        },
        USD: {
            monthly_7_day_trial: 14.99,
            quarterly_7_day_trial: 36.99,
            yearly_7_day_trial: 90.99,
            'monthly_7_day_trial.staging': 14.99,
            'quarterly_7_day_trial.staging': 36.99,
            'yearly_7_day_trial.staging': 90.99,
        },
        EUR: {
            monthly_7_day_trial: 15.49,
            quarterly_7_day_trial: 38.99,
            yearly_7_day_trial: 95.99,
            'monthly_7_day_trial.staging': 15.49,
            'quarterly_7_day_trial.staging': 38.99,
            'yearly_7_day_trial.staging': 95.99,
        },
    },
    bugsnag: 'c8b7dd4e5a92f99d33074eab73240fcb',
    autoApplyCouponsWithPrefix: ['ADMIN']
};

export default Constants;
